<template>
  <div class="sidebar-wrapper">
    <div class="sidebar-logo">
      <router-link to="/">
        <h1 class="sidebar-title">小白资讯管理</h1>
      </router-link>
    </div>

    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.scss";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["sidebar", "addRouters"]),
    routes() {
      // 获取所有路由，包括动态添加的路由
      const staticRoutes = this.$router.options.routes || [];
      const dynamicRoutes = this.addRouters || [];
      console.log("Sidebar routes:", staticRoutes.concat(dynamicRoutes));
      return staticRoutes.concat(dynamicRoutes);
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  watch: {
    addRouters: {
      handler() {
        console.log("addRouters changed, forcing sidebar update");
        this.$forceUpdate();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.sidebar-wrapper {
  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }

  &.has-logo {
    .el-scrollbar {
      height: calc(100% - 50px);
    }
  }

  .is-horizontal {
    display: none;
  }

  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }

  .svg-icon {
    margin-right: 16px;
  }

  .sub-el-icon {
    margin-right: 12px;
    margin-left: -2px;
  }
}

.sidebar-logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: $sidebar-bg;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  a {
    text-decoration: none;
  }

  .sidebar-title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
}
</style>
